import { useFeatureDetails } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

/**
 * Personalized learning-library recommendations for the current user. Only
 * queries when the workspace has GoodHabitz and AI. No keyword fallback when
 * AI is off, so the section stays hidden instead of flashing skeletons.
 */
export default function useLearningRecommendations() {
	const goodHabitzFeature = useFeatureDetails(graphql.FeatureName.Goodhabitz);
	const aiFeature = useFeatureDetails(graphql.FeatureName.Ai);

	const canQuery =
		!goodHabitzFeature.loading &&
		!aiFeature.loading &&
		Boolean(goodHabitzFeature.available) &&
		Boolean(aiFeature.available);

	const recommendations = graphql.useLearningRecommendationsQuery({
		skip: !canQuery,
		fetchPolicy: 'cache-first',
	});

	return {
		available: Boolean(goodHabitzFeature.available && aiFeature.available),
		loading: goodHabitzFeature.loading || aiFeature.loading || recommendations.loading,
		recommendations: canQuery
			? (recommendations.data?.learningRecommendations.recommendations ?? [])
			: [],
	};
}
